const CAROUSEL_ITEMS = [
  {
    title: '甜宠恋爱特辑',
    desc: '霸道总裁、甜蜜契约、先婚后爱……精选最受欢迎甜宠恋爱漫画合集，一口气看到过瘾。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20illustration%20of%20a%20couple%20in%20elegant%20evening%20attire%20at%20a%20luxury%20ball%2C%20warm%20golden%20chandelier%20light%2C%20soft%20romantic%20atmosphere%2C%20shoujo%20manga%20style%2C%20peach%20and%20cream%20tones&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '甜宠恋爱',
  },
  {
    title: '校园纯爱专区',
    desc: '青涩的校园恋爱、同桌的你、樱花树下的告白……最纯粹的校园纯爱漫画都在这里。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20students%20in%20school%20uniforms%20walking%20under%20cherry%20blossom%20trees%20in%20spring%2C%20soft%20sunlight%2C%20warm%20pastel%20colors%2C%20pure%20youthful%20atmosphere%2C%20clean%20shoujo%20art%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '校园纯爱',
  },
  {
    title: '治愈系漫画精选',
    desc: '温暖治愈的恋爱故事，抚慰你的心灵。从青梅竹马到日久生情，每一个故事都让人心头一暖。',
    img: 'https://readdy.ai/api/search-image?query=Heartwarming%20anime%20illustration%20of%20a%20cozy%20cafe%20with%20a%20couple%20sharing%20desserts%20by%20the%20window%2C%20soft%20natural%20light%2C%20warm%20and%20healing%20atmosphere%2C%20gentle%20pastel%20colors%2C%20clean%20manga%20art%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '治愈漫画',
  },
  {
    title: '日漫人气榜单',
    desc: '日本少女漫画最热门作品合集，从经典名作到最新连载，原汁原味的日系甜蜜恋爱。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20illustration%20of%20Tokyo%20cityscape%20at%20sunset%20with%20cherry%20blossom%20petals%20floating%2C%20warm%20golden%20light%2C%20dreamy%20atmosphere%2C%20soft%20pink%20and%20orange%20tones%2C%20clean%20Japanese%20manga%20style&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '日漫精选',
  },
  {
    title: '韩漫甜蜜推荐',
    desc: '韩国纯爱漫画热门推荐，唯美画风与细腻剧情完美结合，带你领略韩系甜蜜恋爱。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20webtoon%20style%20illustration%20of%20a%20romantic%20couple%20in%20a%20beautiful%20garden%20with%20flowers%2C%20soft%20dreamy%20lighting%2C%20delicate%20art%20style%2C%20warm%20peach%20and%20cream%20tones%2C%20clean%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '韩漫推荐',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            焦点专题
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">甜柚漫画精选专题合集</p>
        </div>

        <div className="flex flex-col gap-5">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className={`group flex flex-col ${
                idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-6 rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer`}
            >
              <div className="lg:w-[420px] shrink-0 h-56 lg:h-64 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-6 flex flex-col justify-center">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 w-fit">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-primary-500 text-sm font-medium">
                  浏览专题 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}